import React from "react";
import { Button } from "../Button/Button";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import "./TermsAndConditionsModal.scss";

/**
 * Modal que muestra los términos y condiciones de la aplicación.
 * Utiliza Material-UI Dialog para renderizar el contenido en una ventana modal.
 * @param {boolean} openTermsAndConditions - Estado que controla si el modal está abierto
 * @param {Function} handleCloseTermsAndConditions - Función para cerrar el modal
 * @param {JSX.Element} props.terminos - Contenido HTML que se mostrará dentro del modal.
 * @returns {JSX.Element} Componente TermsAndConditionsModal renderizado
 */
export const TermsAndConditionsModal = ({
  openTermsAndConditions,
  handleCloseTermsAndConditions,
  terminos,
}) => {
  return (
    <Dialog
      maxWidth="sm"
      open={openTermsAndConditions}
      onClose={handleCloseTermsAndConditions}
      className="terms-and-conditions-dialog"
    >
      <DialogTitle className="terms-and-conditions-dialog__title">
        Términos y condiciones
      </DialogTitle>
      <DialogContent>
        <div
          className="terms-and-conditions-dialog__description"
          dangerouslySetInnerHTML={{ __html: terminos }}
        />
      </DialogContent>
      <DialogActions>
        <div className="terms-and-conditions-dialog__actions">
          <Button
            onClick={handleCloseTermsAndConditions}
            autoFocus
            size="medium"
          >
            Aceptar
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};
